// src/services/api.js

import axios from 'axios';

const API_URL = '/api';

export const dashboardService = {
  // Authentification
  async register(userData) {
    return axios.post(`${API_URL}/users/register`, userData);
  },


  async checkUsername(username) {
    return axios.get(`${API_URL}/users/check-username/${username}`);
  },

  
  async confirmRegistration(token, password) {
    return axios.post(`${API_URL}/users/confirm`, {
      token: token,
      password: password
    });
  },

  async login(credentials) {
    return axios.post(`${API_URL}/users/login`, credentials);
  },

  async logout() {
    return axios.post(`${API_URL}/users/logout`);
  },

  // Dashboard
  async getDashboardData(userId) {
    return axios.get(`${API_URL}/data/dashboard/${userId}`);
  },

  // Profile - Utiliser userParam qui peut être un ID ou un username
  async getProfile(userParam) {
    return axios.get(`${API_URL}/data/profile/${userParam}`);
  },
  
  async updateProfile(userId, data) {
    return axios.put(`${API_URL}/data/profile/${userId}`, data);
  },

  async uploadAvatar(userId, formData) {
    return axios.post(`${API_URL}/data/avatar/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Social Links - Utiliser userParam qui peut être un ID ou un username
  async getSocialLinks(userParam) {
    return axios.get(`${API_URL}/data/social-links/${userParam}`);
  },

  async addSocialLink(userId, data) {
    return axios.post(`${API_URL}/data/social-links/${userId}`, data);
  },

  async updateSocialLink(userId, linkId, data) {
    return axios.put(`${API_URL}/data/social-links/${userId}/${linkId}`, data);
  },

  async deleteSocialLink(userId, linkId) {
    return axios.delete(`${API_URL}/data/social-links/${userId}/${linkId}`);
  },

  // Photos - Utiliser userParam qui peut être un ID ou un username
  async getPhotos(userParam) {
    return axios.get(`${API_URL}/data/photos/${userParam}`);
  },

  async addPhoto(userId, formData) {
    return axios.post(`${API_URL}/data/photos/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  async deletePhoto(userId, photoId) {
    return axios.delete(`${API_URL}/data/photos/${userId}/${photoId}`);
  },

  // neolink User WEBpage data
  async getUserProfile(userParam) {
    return axios.get(`${API_URL}/data/profile/${userParam}`);
  },

  async getUserSocialLinks(userParam) {
    return axios.get(`${API_URL}/data/social-links/${userParam}`);
  },

  async getUserPhotos(userParam) {
    return axios.get(`${API_URL}/data/photos/${userParam}`);
  },

  // Packages et Abonnements
  async getPackages() {
    return axios.get(`${API_URL}/data/packages`);
  },

  async subscribe(data) {
    return axios.post(`${API_URL}/data/subscribe`, data);
  },
  
  async getSubscription(userId) {
    return axios.get(`${API_URL}/data/subscription/${userId}`);
  },

  async processSubscription(data) {
    return axios.post(`${API_URL}/data/process-subscription`, data);
  },

  // Utilitaires
  async getUserByUsername(username) {
    return axios.get(`${API_URL}/data/user/${username}`);
  },

  isLoggedIn() {
    const user = localStorage.getItem('user');
    return user ? true : false;
  },

// Dans services/api.js
async generateQRCode(userId) {
  return axios.post(`${API_URL}/data/qrcode/${userId}`);
},
  // Dans services/api.js, assurez-vous que la route est correcte
async processSubscriptionCash(data) {
  return axios.post(`${API_URL}/data/process-subscription-cash`, data);
},
  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },


  // Dans services/api.js

  async initiateWafiPayment(data) {
    console.log('🚀 API: Initiation paiement WaafiPay', data);
    return axios.post(`${API_URL}/payment/wafi-initiate`, data);
  },


  // src/services/api.js - Ajoutez ces méthodes
async forgotPassword(email) {
  return axios.post(`${API_URL}/users/forgot-password`, { email });
},

async resetPassword(token, password) {
  return axios.post(`${API_URL}/users/reset-password`, { token, password });
},



// Télécharger une image de couverture
// Télécharger une image de couverture
// Télécharger une image de couverture
// Dans src/services/api.js
async uploadBanner(userId, formData) {
  return axios.post(`${API_URL}/data/banner/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
},


// Enregistrer une vue de profil
async recordProfileView(userId, deviceInfo) {
  return axios.post(`${API_URL}/data/analytics/view/${userId}`, { deviceInfo });
},

// Enregistrer un clic sur un lien
async recordLinkClick(userId, linkId) {
  return axios.post(`${API_URL}/data/analytics/click/${userId}/${linkId}`);
},

// Obtenir les statistiques du tableau de bord
async getDashboardStats(userId) {
  return axios.get(`${API_URL}/data/dashboard/stats/${userId}`);
}, 




// Theme management features 
async getAllThemes() {
  return axios.get(`${API_URL}/data/themes`);
},

async getUserTheme(userParam) {
  return axios.get(`${API_URL}/data/theme/${userParam}`);
},

async updateUserTheme(userId, themeId) {
  return axios.put(`${API_URL}/data/theme/${userId}`, { themeId });
},





// Custom Links - Utiliser userParam qui peut être un ID ou un username
async getCustomLinks(userParam) {
  return axios.get(`${API_URL}/data/custom-links/${userParam}`);
},

async addCustomLink(userId, data) {
  return axios.post(`${API_URL}/data/custom-links/${userId}`, data);
},

// Nouvelle méthode pour l'ajout avec icône (FormData)
async addCustomLinkWithIcon(userId, formData) {
  return axios.post(`${API_URL}/data/custom-links/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
},

async updateCustomLink(userId, linkId, data) {
  return axios.put(`${API_URL}/data/custom-links/${userId}/${linkId}`, data);
},

// Nouvelle méthode pour la mise à jour avec icône (FormData)
async updateCustomLinkWithIcon(userId, linkId, formData) {
  return axios.put(`${API_URL}/data/custom-links/${userId}/${linkId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
},

async deleteCustomLink(userId, linkId) {
  return axios.delete(`${API_URL}/data/custom-links/${userId}/${linkId}`);
},

// Upload d'icône seule
async uploadCustomIcon(userId, formData) {
  return axios.post(`${API_URL}/data/upload-custom-icon/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
},

// Pour le profil public
async getUserCustomLinks(userParam) {
  return axios.get(`${API_URL}/data/custom-links/${userParam}`);
}, 




async getServices(userId) {
  return axios.get(`${API_URL}/data/users/${userId}/services`);
},

async addService(userId, serviceData) {
  return axios.post(`${API_URL}/data/users/${userId}/services`, serviceData);
},

async deleteService(userId, serviceId) {
  return axios.delete(`${API_URL}/data/users/${userId}/services/${serviceId}`);
},

async uploadServiceIcon(userId, serviceId, formData) {
  return axios.post(`${API_URL}/data/users/${userId}/services/${serviceId}/icon`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
},

// MÉTHODE MANQUANTE - À AJOUTER :
async getUserServices(username) {
  return axios.get(`${API_URL}/data/users/${username}/services`);
},

};


// Ajoutez ces méthodes à votre objet dashboardService existant

// Admin API
const adminService = {
  // Vérifier si l'utilisateur est administrateur
  isAdmin() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user && user.is_admin === 1;
  },

  // Authentification admin
// Dans votre service api.js

// Dans la fonction loginAdmin de votre service api.js
async loginAdmin(credentials) {
  console.log('Login admin - Tentative de connexion');
  try {
    // Utiliser exactement la même méthode que le login normal
    // puisque c'est la même endpoint
    const response = await axios.post(`${API_URL}/users/login`, credentials);
    
    if (response.data.success) {
      // Vérifier si l'utilisateur est admin APRÈS une connexion réussie
      if (response.data.data.is_admin === 1) {
        console.log('Connexion admin réussie');
        // Stocker l'utilisateur
        localStorage.setItem('user', JSON.stringify(response.data.data));
        return response;
      } else {
        console.log('Utilisateur non admin');
        throw new Error('Accès non autorisé - Compte non administrateur');
      }
    } else {
      console.log('Échec de connexion:', response.data.message);
      throw new Error(response.data.message || 'Échec de connexion');
    }
  } catch (error) {
    console.error('Erreur de connexion admin:', error);
    throw error;
  }
},

  // Gestion des utilisateurs
  async getUsers(page = 1, limit = 10, search = '') {
    return axios.get(`${API_URL}/admin/users?page=${page}&limit=${limit}&search=${search}`);
  },

  async updateUserStatus(userId, status) {
    return axios.put(`${API_URL}/admin/users/${userId}/status`, { status });
  },

  async deleteUser(userId) {
    return axios.delete(`${API_URL}/admin/users/${userId}`);
  },

  // Gestion des abonnements
  async getSubscriptions(page = 1, limit = 10, status = null) {
    let url = `${API_URL}/admin/subscriptions?page=${page}&limit=${limit}`;
    if (status !== null) {
      url += `&status=${status}`;
    }
    return axios.get(url);
  },

  async toggleSubscriptionStatus(subscriptionId, status) {
    return axios.put(`${API_URL}/admin/subscriptions/${subscriptionId}/status`, { status });
  },

  async changeSubscriptionPackage(subscriptionId, packageId) {
    return axios.put(`${API_URL}/admin/subscriptions/${subscriptionId}/package`, { packageId });
  },

  // Gestion des paiements
// Gestion des paiements
async getPayments(page = 1, limit = 10, status = null) {
  let url = `${API_URL}/admin/payments?page=${page}&limit=${limit}`;
  if (status) {
    url += `&status=${status}`;
  }
  return axios.get(url);
},

async approvePayment(paymentId) {
  return axios.put(`${API_URL}/admin/payments/${paymentId}/approve`);
},

async rejectPayment(paymentId) {
  return axios.put(`${API_URL}/admin/payments/${paymentId}/reject`);
},

// Statistiques
async getStatistics() {
  return axios.get(`${API_URL}/admin/statistics`);
},

// Création d'un autre administrateur (réservé aux admins)
async createAdmin(adminData) {
  return axios.post(`${API_URL}/admin/create`, adminData);
},

// Dans adminService
async activateUserSubscription(userId, packageId) {
  return axios.post(`${API_URL}/admin/users/${userId}/activate-subscription`, { packageId });
}
};


// Exportez adminService
export { adminService };
export default dashboardService;
